import { useState, useEffect } from "react";
import data from "../../json-server/db.json"; // Assure-toi que le chemin est correct

const PortfolioOne = () => {
  const [portfolioItems, setPortfolioItems] = useState([]);

  useEffect(() => {
    // Charger les 4 premiers éléments de "portfolio"
    setPortfolioItems(data.portfolio.slice(0, 4));
  }, []);

  return (
    <div className="row">
      <div className="stack-wrapper">
        {portfolioItems.map((item) => (
          <div className="stack-item" key={item.id}>
            <div className="card portfolio-item layout-2 scale has-shadow">
              <div className="image-holder">
                <a className="card-thumb" href={item.projectLink}>
                  <img src={item.image} alt={item.title} />
                </a>
                <div className="card-overlay">
                  <div className="heading">
                    <h4 className="title mt-2 mt-md-3 mb-3">{item.title}</h4>
                    <div className="show-project">
                      <div className="card-terms">
                        {item.categories.map((category, index) => (
                          <a className="terms badge outlined" href="/portfolio" key={index}>
                            {category}
                          </a>
                        ))}
                      </div>
                      <div className="project-link">
                        <a href={item.projectLink}>Montrer le projet</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PortfolioOne;
